import { message } from 'antd';
import type { AxiosResponse } from 'axios';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import { client } from '@portal/api-client/src/client';
import type { Feedback } from '@portal/api-models';

import { selectUserState } from '../user/selectors';
import type { UserState } from '../user/types';

import { feedbackCreateRequestAction, toggleFeedbackDrawer } from './actions';

export function* createFeedback(
  action: ActionType<typeof feedbackCreateRequestAction.request>
) {
  try {
    const { claims }: UserState = yield select(selectUserState);

    const formParams = action.payload;

    const params: Feedback = {
      comment: formParams.comment!,
      email: claims?.email ?? '',
      feedbackType: formParams.feedbackType!,
      name: claims?.name ?? '',
    };

    const { data: created }: AxiosResponse<Feedback> = yield call(
      [client, 'post'],
      '/feedback',
      params
    );

    yield put(feedbackCreateRequestAction.success(created));

    yield put(toggleFeedbackDrawer());
    yield call([message, 'success'], 'Feedback submitted');
  } catch (err: any) {
    yield put(feedbackCreateRequestAction.failure(err));
  }
}

export function* feedbackSaga() {
  yield takeEvery(getType(feedbackCreateRequestAction.request), createFeedback);
}
